import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import CalendarFilterDropdown, {
  CALENDAR_FILTER_DROPDOWN_WRAP_CLASSNAME,
} from '../../tab_todo/viewComponents/CalendarFilterDropdown';
import MonthYearPickerDropdown from './MonthYearPickerDropdown';

const CalendarHeader = ({
  currentMonth,
  minPickerYear,
  maxPickerYear,
  onSelectMonth,
  onToday,
  calendars = [],
  calendarFilterValue,
  onCalendarFilterChange,
  eventSearch = '',
  onEventSearchChange,
  onGoogleManualSync,
  googleSyncBusy = false,
}) => {
  const isCurrentMonth =
    currentMonth.getMonth() === new Date().getMonth() &&
    currentMonth.getFullYear() === new Date().getFullYear();

  return (
    <div className="flex w-full min-w-0 max-w-full flex-nowrap items-center gap-2 py-1.5 sm:justify-between sm:gap-3">
      {/* Left: month/year + picker */}
      <div className="flex min-w-0 flex-1 items-center gap-1.5 sm:gap-2">
        <MonthYearPickerDropdown
          currentMonth={currentMonth}
          minYear={minPickerYear}
          maxYear={maxPickerYear}
          onSelectMonth={onSelectMonth}
        />
      </div>

      {/* Direita */}
      <div className="flex min-w-0 shrink items-center gap-1.5 sm:gap-2">
        <button
          onClick={onToday}
          className={`shrink-0 whitespace-nowrap px-2 py-1 text-xs font-medium rounded-lg transition-colors sm:px-2.5 sm:text-sm ${
            isCurrentMonth
              ? 'text-gray-400 cursor-not-allowed'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
          disabled={isCurrentMonth}
        >
          Today
        </button>
        {typeof onGoogleManualSync === 'function' ? (
          <button
            type="button"
            onClick={onGoogleManualSync}
            disabled={googleSyncBusy}
            title="Sync with Google Calendar"
            aria-busy={googleSyncBusy}
            aria-label="Sync with Google Calendar"
            className="shrink-0 rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 disabled:pointer-events-none disabled:opacity-40"
          >
            <ArrowPathIcon
              className={`h-[1.125rem] w-[1.125rem] sm:h-5 sm:w-5 ${googleSyncBusy ? 'animate-spin' : ''}`}
              aria-hidden
            />
          </button>
        ) : null}
        <input
          type="search"
          value={eventSearch}
          onChange={(e) => onEventSearchChange?.(e.target.value)}
          placeholder="Search events"
          aria-label="Search events by name or description"
          className="w-full max-w-[8rem] min-w-0 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700 shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 sm:max-w-[12rem] md:max-w-[14rem]"
        />
        <div className={CALENDAR_FILTER_DROPDOWN_WRAP_CLASSNAME}>
          <CalendarFilterDropdown
            multiple
            fullWidthTrigger={false}
            calendars={calendars}
            value={calendarFilterValue}
            onChange={onCalendarFilterChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
